import { render, staticRenderFns } from "./PurchaseDocumentContainsFilter.vue?vue&type=template&id=2efdc9b8"
import script from "./PurchaseDocumentContainsFilter.vue?vue&type=script&lang=ts"
export * from "./PurchaseDocumentContainsFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports